<template>
  <v-dialog
    width="600"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    v-model="opened"
    @keydown.esc="$emit('update:opened', false)"
    persistent
  >
    <v-card flat>
      <v-card-title>
        <h2>Document in Process</h2>
        <v-spacer />
        <v-btn
          small
          fab
          flat
          class="white error--text text-capitalize ma-0"
          @click="$emit('update:opened', false)"
        >
          <v-icon size="20"> clear </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="text-xs-left pt-0">
        Please wait for a few seconds while the document is currently being
        processed. If you wish to bypass the processing, you can click on the
        "Cancel Processing" button. However, please note that if you choose to
        do so, you will have to add the signature boxes manually.
      </v-card-text>

      <v-card-actions>
        <v-btn
          block
          outline
          color="error"
          class="default-input text-none"
          @click="$emit('cancelProcessing')"
        >
          Cancel Processing
        </v-btn>

        <v-btn
          block
          color="primary"
          class="default-input text-none"
          @click="$emit('update:opened', false)"
        >
          Close and Wait for Processing
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
    },
  },

  data() {
    return {};
  },
};
</script>

<style lang="postcss"></style>
